import React from "react";
import Grid from "@material-ui/core/Grid";
import Layout from "Layout";
import { Button, Typography } from "@material-ui/core";
import CommentIcon from '@material-ui/icons/Comment';
import Chart from "Components/Chart";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import DatePickers from "Components/DatePickers";
import DateSinglePicker from "Components/DateSinglePicker";
import DateTimePicker from "Components/DateTimePicker";
import PosiTabs from "Components/PosiTabs";
import useApi from "Hooks/useApi";
import useAuth from "Hooks/useAuth";
import useFilter from "Hooks/useFilter";
import googleAnalytics from "fuction/googleAnalytics";
import {useQueryString} from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  headDate: {
    paddingLeft: 90,
    paddingRight: 90,
    marginBottom: theme.spacing(2),
  },
}));

export default function KeywordMonthly(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const filter = useFilter();
  const queryParams = useQueryString();
  const [meta, setMeta] = React.useState({});
  const [graph, setGraph] = React.useState([]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - キーワード分析";
  }, []);

  React.useEffect(() => {
    googleAnalytics(window.location.pathname, auth.state.user.account_id);
  }, [window.location.pathname]);

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで画面表示されてしまう。
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得しても画面に反映されない（set○○(●●)までで再々レンダは走らない）ので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }

    Promise.all([
      request({
        method: "GET",
        url: `data/:account_id/keywords/${
          auth.state.activeGroup
        }?${convertQueryParam({
          keyword: props.word,
          unit: props.unit,
          range: [props.fromDate, props.toDate],
          filter: {
            pn: filter.state.posiNegaTab,
          },
        })}`,
      }),
    ]).then(([graph]) => {
      setMeta(graph.meta);
      setGraph(graph);
    });
  }, [
    auth.state.activeGroup,
    props.fromDate,
    props.toDate,
    filter.state.posiNegaTab,
  ]);

  const classes = useStyles();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const HeadDate = () => {
    if (props.target === "monthly") {
      return (
        <Grid item xs={12} className={classes.headDate}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DatePickers />
            <div className={classes.divider}></div>
            <PosiTabs />
          </Grid>
        </Grid>
      );
    }
    if (props.target === "daily") {
      return (
        <Grid item xs={12} className={classes.headDate}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DateSinglePicker
              date={props.fromDate}
              onChange={(date) => props.handleChangeDateSingle(date)}
            />
            <div className={classes.divider}></div>
            <PosiTabs />
          </Grid>
        </Grid>
      );
    }
    if (props.target === "hourly") {
      return (
        <Grid item xs={12} className={classes.headDate}>
          <Grid
            container
            direction="row"
            alignItems="flex-end"
            justifyContent="flex-start"
          >
            <DateTimePicker
              dateTime={props.fromDate}
              handleDateChange={props.handleDateChange}
              step={60}
            />
            <div className={classes.divider}></div>
            <PosiTabs />
          </Grid>
        </Grid>
      );
    }
  };
  return (
    <Layout
      content={
        <Grid>
          <HeadDate />
          <Grid container>
            <Typography>{meta.keyword}：</Typography>
            <Typography>{meta.total_count}件</Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper className={fixedHeightPaper}>
              <Chart
                data={graph.data}
                dataKey={props.unit}
                onClick={(date) => props.onClickLineChart(date)}
              />
              <Grid container justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<CommentIcon />}
                  onClick={() => props.onClickListButton(props.fromDate)}
                >
                  投稿一覧
                </Button>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      }
    />
  );
}
